var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3558_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2759 1.17192C16.5905 1.52065 15.372 2.25417 14.4741 2.85542C11.2474 5.02393 8.5618 7.83377 7.24707 10.4111L7.06669 10.7719L6.9745 10.6797C6.9264 10.6276 6.3492 9.9662 5.69584 9.21264C5.04248 8.45907 4.46127 7.80571 4.40115 7.75761C4.30094 7.67745 4.25284 7.67745 2.2607 7.67745H0.224467L0.112233 7.77365C0.0160333 7.85782 0 7.90191 0 8.07427C0 8.25064 0.0160333 8.29473 0.1443 8.427C0.224467 8.51118 1.95206 10.3831 3.98829 12.5877C6.02052 14.7922 7.76414 16.6721 7.86034 16.7643C8.04472 16.9487 8.20506 16.9848 8.40948 16.8926C8.54577 16.8325 8.57382 16.7643 8.76222 16.0749C9.85649 12.0345 12.041 8.01815 14.9912 4.6271C15.5243 4.01784 17.1036 2.43455 17.6046 2.00966C18.0094 1.66895 18.0776 1.54069 17.9774 1.30019C17.8692 1.04366 17.6166 0.995555 17.2759 1.17192Z",
    fill: "#32B604"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3558_3292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/rightIcon.0f04e9b66bf65a76b7c70de86599ce94.svg";
export { ForwardRef as ReactComponent };